'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import { cn } from '~/lib/utils';
interface FixedFooterProps {
  children: React.ReactNode;
}

export function FixedFooter(props: FixedFooterProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isPC = window.innerWidth > 768; // PCの判定
      const threshold = isPC ? 800 : 320; // PCとSPの閾値

      if (scrollY > threshold) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={cn(
        'p-2 fixed bottom-0 left-0 right-0 z-10 bg-black bg-opacity-50 transition-opacity duration-300',
        isOpen && !isClosed ? 'opacity-100' : 'opacity-0 pointer-events-none',
      )}
    >
      {props.children}
      <button
        type="button"
        className="absolute top-2 right-2"
        onClick={() => setIsClosed(true)}
      >
        <Image
          alt="閉じるアイコン"
          src="/nextjs/images/icons/btn_white_close.png"
          width={18}
          height={18}
        />
      </button>
    </div>
  );
}
